<template>
  <div class="betslip__item">
    <div class="betslip__title">
      <div class="betslip--dates">
        <span> <i class="date-label">created-at:</i>  {{ logs.created_at | date }} </span> <br>
        <span v-if="logs.isHide"><i class="date-label">delete-at:</i> {{ logs.deleted_at | date }} </span>
      </div>
      <div
        class="betslip--buttons -buttons"
      >
        <button
          class="btn--cancel"
          v-if="!logs.isCancel &&
            !logs.isHide &&
            !logs.isResult"
          @click="updateCard('cancel', logs)"
        >
          <i class="ico--clear"></i>
        </button>
        <button
          class="btn--delete"
          v-if="!logs.isResult &&
            !logs.isHide"
          @click="updateCard('delete', logs)"
        >
          <i class="ico--delete"></i>
        </button>
        <button
          class="btn--restore"
          v-if="logs.isHide"
          @click="updateCard('restore', logs)"
        >
          <i class="ico--restore"></i>
        </button>
      </div>
    </div>
    <div class="betslip-user">
      <span>User: </span>
      <span
        v-if="logs.user"
        @click="openUser(logs.user.id, 'info')"
      >{{logs.user.login_name}}</span>
    </div>
    <slot></slot>
    <div class="betslip__footer">
      <div class="betslip--inner-con">
        <div class="betslip--inner-items">
          <div class="-date">
            {{ logs.created_at | date }}
          </div>
          <div class="-total-odds">
            <span class="label">배당률:</span>
            <span class="value">{{ estTotalOdds }}</span>
          </div>
          <div class="-actual-odds">
            <span class="label">실제 확률:</span>
            <span class="value">{{ actualOdds }}</span>
          </div>
          <div class="-total-bets">
            <span class="label">베팅금:</span>
            <span class="value">{{ logs.bet_amount | FormatAmount }}</span>
          </div>
        </div>
        <div class="betslip--inner-items">
          <div class="-est-wins">
            <span class="label">예상 당첨금:</span>
            <span class="value">{{ estTotalWins | FormatAmount }}</span>
          </div>
          <div class="-wins">
            <span class="label">당첨금:</span>
            <span class="value">{{ (logs.bet_amount * actualOdds) | FormatAmount }}</span>
          </div>
          <div class="-status">
            <span class="label">상태:</span>
            <span class="value">{{ checkStatus }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import FormatAmount from '@/assets/js/filters/FormatAmount'

export default {
  filters: {
    FormatAmount
  },

  props: {
    logs: {}
  },

  computed: {
    estTotalOdds () {
      let totalOdds = 1

      this.logs.userBets.forEach((data) => {
        totalOdds *= parseFloat(data[`${data.betArea}_val`])
      })
      // return parseFloat(parseFloat(totalOdds).toFixed(3))
      return Math.round((totalOdds) * 10000) / 10000
    },

    actualOdds () {
      let actualOdds = 1

      this.logs.userBets.forEach((data) => {
        actualOdds *= parseFloat(data.result_modifier).toFixed(2)
      })

      return parseFloat(actualOdds).toFixed(2)
    },

    estTotalWins () {
      let totalBets = parseFloat(this.logs.bet_amount).toFixed(2)
      let totalOdds = this.estTotalOdds
      let result = 0

      result = totalBets * totalOdds

      return result.toFixed(2)
    },

    checkStatus () {
      let status = ''

      if (this.logs.isBetting) {
        status = 'Betting'
      }

      if (this.logs.isCancel) {
        status = 'Cancelled'
      }

      if (this.logs.isResult) {
        status = 'Done'
      }

      if (this.logs.isHide) {
        status = 'Deleted'
      }

      return status
    }
  },

  methods: {
    ...mapActions('bet-history',
      ['get', 'restore', 'cancel', 'delete']),

    async updateCard (action, log) {
      let data = {
        action: action,
        id: log.id
      }

      let params = {}
      params.id = data.id
      if (data.action === 'cancel') {
        params.isCancel = 1
        await this.cancel(params)
      }

      if (data.action === 'delete') {
        await this.delete(params)
        log.deleted_at = new Date()
      }

      if (data.action === 'restore') {
        params.isHide = 0
        await this.restore(params)
      }
    },
    openUser (id, subtype) {
      window.open(
        `${process.env.VUE_APP_URL}/user/${id}/${subtype}`,
        '',
        `width=${1400},height=${window.innerHeight}`
      )
    }
  }
}
</script>
